import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { QUERY_PARAMS, ROUTES } from '@shared/config';
import { map } from 'rxjs/operators';
import { SessionService } from '@security/session.service';

@Injectable({ providedIn: 'root' })
export class LoginRedirectGuard implements CanActivate {
  constructor(
    private readonly session: SessionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.session
      .resolve()
      .pipe(
        map(authenticated =>
          authenticated ? this.redirectToReturnUrl(route) : true
        )
      );
  }

  private redirectToReturnUrl(route: ActivatedRouteSnapshot): false {
    const target =
      route.queryParamMap.get(QUERY_PARAMS.returnUrl) || ROUTES.home;
    this.router.navigateByUrl(target, { replaceUrl: true });
    return false;
  }
}
